import ProfilePicture from "@govlaunch/profile-picture";
import shuffle from "lodash/fp/shuffle";
import React, { useMemo } from "react";
import useIsMobile from "~/lib/hooks/useIsMobile";
import mediaQueries from "~/components/mediaQueries";

export default function WhoIsIn() {
  const isMobile = useIsMobile();

  const seals = useMemo(() => {
    return shuffle(SEALS);
  }, []);

  return (
    <div
      css={mediaQueries({
        display: "grid",
        gridRowGap: 30,
        gridColumnGap: [18, 18, 18, 30],
        gridTemplateColumns: ["repeat(4, auto)", "repeat(4, auto)", "repeat(4, auto)", "repeat(8, auto)"],
        justifyContent: "center",
      })}
    >
      {seals.slice(0, isMobile ? 4 : 8).map(({ src, alt }) => {
        return <ProfilePicture key={alt} size={isMobile ? 65 : 108} image={src} name={alt} aria-label={alt} />;
      })}
    </div>
  );
}

// NOTE: exported from the database. Seals of all active governments as of 9/12/2019
const SEALS = [
  {
    src: "https://cdn.filestackcontent.com/yRjKjYySRH69TPm4hObD",
    alt: "Carlsbad",
  },
  {
    src: "https://cdn.filestackcontent.com/j0Q8xMnJQSybAHp6PV1t",
    alt: "Chula Vista",
  },
  {
    src: "https://cdn.filestackcontent.com/mOetyuOGSWGf5bcYWQNw",
    alt: "Bakersfield",
  },
  {
    src: "https://cdn.filestackcontent.com/83YCj8HKTuS7JmX42LaJ",
    alt: "Chico",
  },
  {
    src: "https://cdn.filestackcontent.com/ZBnqhSvTTzyV9wUyIwu0",
    alt: "Glendale",
  },
  {
    src: "https://cdn.filestackcontent.com/I5wfsqZNQ2XBnsyJDU4G",
    alt: "Manteca",
  },
  {
    src: "https://cdn.filestackcontent.com/k2P41btRaqoR0OAeqXiS",
    alt: "Modesto",
  },
  {
    src: "https://cdn.filestackcontent.com/x01dVk8RF2C1xS7jSj70",
    alt: "West Sacramento",
  },
  {
    src: "https://cdn.filestackcontent.com/LhXRB9WjSU64fo7F7rHi",
    alt: "Coronado",
  },
  {
    src: "https://cdn.filestackcontent.com/vcMsQifPTnGTxZ6kqiiK",
    alt: "San Leandro",
  },
  {
    src: "https://cdn.filestackcontent.com/IIYyyN2SjugVAX72baBO",
    alt: "Santa Clara County",
  },
  {
    src: "https://cdn.filestackcontent.com/YZpH77dhTdqEYmraMPFk",
    alt: "Centennial",
  },
  {
    src: "https://cdn.filestackcontent.com/aBZ7XCCSMiCWEYLbS1Bg",
    alt: "Broomfield",
  },
  {
    src: "https://cdn.filestackcontent.com/Mdj9LZipRdGXbcQWAdHl",
    alt: "Fort Collins",
  },
  {
    src: "https://cdn.filestackcontent.com/zQs19779TVOPOa0PPZcE",
    alt: "Eagle County",
  },
  {
    src: "https://cdn.filestackcontent.com/lEHJCJdvQq2W5sx3Bfhc",
    alt: "Gunnison County",
  },
  {
    src: "https://cdn.filestackcontent.com/TT7oyuaaR6O9bVhdKErk",
    alt: "Mesa County",
  },
  {
    src: "https://cdn.filestackcontent.com/UA6GUGmISN2MrJtVZYTN",
    alt: "Haines",
  },
  {
    src: "https://cdn.filestackcontent.com/t4iSb4jkSKCc6ACQ0iUO",
    alt: "Tallahassee",
  },
  {
    src: "https://cdn.filestackcontent.com/tptkSpSDiGxVzi3li4QS",
    alt: "Coral Gables",
  },
  {
    src: "https://cdn.filestackcontent.com/mwpsBDQMRZ6dspFfOSJA",
    alt: "Coral Springs",
  },
  {
    src: "https://cdn.filestackcontent.com/2J6plSJNRuOam0hMlAUC",
    alt: "Fort Lauderdale",
  },
  {
    src: "https://cdn.filestackcontent.com/zw3PWwZJQ6yzuHpPuoOp",
    alt: "Lakeland",
  },
  {
    src: "https://cdn.filestackcontent.com/1Qa1dqw8SvKiPp6hW9Pl",
    alt: "Largo",
  },
  {
    src: "https://cdn.filestackcontent.com/rIfzDEWRui9VvHnRRoYg",
    alt: "Santa Rosa County",
  },
  {
    src: "https://cdn.filestackcontent.com/mkddeHSAyTF8gAfcCBjA",
    alt: "Elmwood Park",
  },
  {
    src: "https://cdn.filestackcontent.com/RJnNe1JMTjGlMMrZnkez",
    alt: "Fulton County",
  },
  {
    src: "https://cdn.filestackcontent.com/D8EebhMeSdOR7CMopU6P",
    alt: "Lemont",
  },
  {
    src: "https://cdn.filestackcontent.com/3TgmtjORKmuP2JzyOoox",
    alt: "Naperville",
  },
  {
    src: "https://cdn.filestackcontent.com/AbbsmgIaQbaybWzPk711",
    alt: "Park Ridge",
  },
  {
    src: "https://cdn.filestackcontent.com/2izD6b6sTHuMxMY6QcmJ",
    alt: "Campton Hills",
  },
  {
    src: "https://cdn.filestackcontent.com/squciuT9TZmjdJi78QeN",
    alt: "Aurora",
  },
  {
    src: "https://cdn.filestackcontent.com/DDp2ayHKRnufl8RRGLOE",
    alt: "Channahon",
  },
  {
    src: "https://cdn.filestackcontent.com/d2wAkimNTdGtmXwSjybB",
    alt: "Highland Park",
  },
  {
    src: "https://cdn.filestackcontent.com/K8XalwfNQTmItYzog5tM",
    alt: "Winnetka",
  },
  {
    src: "https://cdn.filestackcontent.com/X4hHt9IkRjKQbofh0Ds8",
    alt: "Beverly",
  },
  {
    src: "https://cdn.filestackcontent.com/ylqj9RVZRnisQ9yybk49",
    alt: "Dudley",
  },
  {
    src: "https://cdn.filestackcontent.com/GOpDsSCbSHqvin2iAkky",
    alt: "Chelmsford",
  },
  {
    src: "https://cdn.filestackcontent.com/6ooCqwyaQ2ukSNEcwuwM",
    alt: "Wareham",
  },
  {
    src: "https://cdn.filestackcontent.com/GlhdCLWJR0KCyy46VvAt",
    alt: "West Springfield",
  },
  {
    src: "https://cdn.filestackcontent.com/eHOJEtsGSIOXh3T9Iatc",
    alt: "Irving",
  },
  {
    src: "https://cdn.filestackcontent.com/5EhlMgQSa22Usc09JvBw",
    alt: "Bexar County",
  },
  {
    src: "https://cdn.filestackcontent.com/BkuH0WzeSUmNLIjY5Hyx",
    alt: "Calhoun County",
  },
  {
    src: "https://cdn.filestackcontent.com/RlClnWeyTHmNvI3o2YwJ",
    alt: "Canyon",
  },
  {
    src: "https://cdn.filestackcontent.com/AgnPgMjbQU2F5lfK3TME",
    alt: "Southlake",
  },
  {
    src: "https://cdn.filestackcontent.com/XBtdB9BAQDmevJVsXHv0",
    alt: "Denton County",
  },
  {
    src: "https://cdn.filestackcontent.com/G0Pdo9eoRzmDmLEEpKO3",
    alt: "Willacy County",
  },
  {
    src: "https://cdn.filestackcontent.com/c0cUz5smRV6xB5Luo9aA",
    alt: "Dallas County",
  },
  {
    src: "https://cdn.filestackcontent.com/rBqjX02STtK3l0qOWT3k",
    alt: "Georgetown",
  },
  {
    src: "https://cdn.filestackcontent.com/9jInwXpMQWqg9L8TtbOS",
    alt: "Harris County",
  },
  {
    src: "https://cdn.filestackcontent.com/u9ABof11T8miaoafQNTJ",
    alt: "Mineral Wells",
  },
  {
    src: "https://cdn.filestackcontent.com/6AjVRrb9RP2nKV1hMHgB",
    alt: "Reeves County",
  },
  {
    src: "https://cdn.filestackcontent.com/CsiWCJH3TiW1eLEkAkSY",
    alt: "Rockdale",
  },
  {
    src: "https://cdn.filestackcontent.com/2UD2HHN7QhacM1iOiLwZ",
    alt: "Sugar Land",
  },
  {
    src: "https://cdn.filestackcontent.com/v0eX4ObeSH8awiOESIkW",
    alt: "Danbury",
  },
  {
    src: "https://cdn.filestackcontent.com/opuGolutQXmmird3206a",
    alt: "New Britain",
  },
  {
    src: "https://cdn.filestackcontent.com/QvEGJoySX2L831AcTdbd",
    alt: "South Windsor",
  },
  {
    src: "https://cdn.filestackcontent.com/HV5SdXdTweYKBRTTvu7q",
    alt: "Suffolk County",
  },
  {
    src: "https://cdn.filestackcontent.com/6UhiacQ77iTAanc3bQBh",
    alt: "Erie County",
  },
  {
    src: "https://cdn.filestackcontent.com/UfpDCAo2QhGHavk6WTfX",
    alt: "Rochester",
  },
  {
    src: "https://cdn.filestackcontent.com/lGmtBa1hRJ0fNg1aJACL",
    alt: "Syracuse",
  },
  {
    src: "https://cdn.filestackcontent.com/sR4Lvt8SRO3saMzLFMAY",
    alt: "Chautauqua County",
  },
  {
    src: "https://cdn.filestackcontent.com/e4I55vRT6a36yclPqz2J",
    alt: "Floral Park",
  },
  {
    src: "https://cdn.filestackcontent.com/s97qTh0MScml7I9lUdC5",
    alt: "Los Angeles County",
  },
  {
    src: "https://cdn.filestackcontent.com/Klyl0DmZR66auz5cI5Uk",
    alt: "Cypress",
  },
  {
    src: "https://cdn.filestackcontent.com/8tLg6wjLRqmjj8EPWjZ2",
    alt: "Ferndale",
  },
  {
    src: "https://cdn.filestackcontent.com/fTBOLOwzR82DQZmL9BML",
    alt: "Fresno",
  },
  {
    src: "https://cdn.filestackcontent.com/BKRIfwO7S2eev73ORF57",
    alt: "Contra Costa County",
  },
  {
    src: "https://cdn.filestackcontent.com/1oOFSmNNSSKSwTNsTjuR",
    alt: "Menlo Park",
  },
  {
    src: "https://cdn.filestackcontent.com/LS8UEtY0TReKNkFiLn95",
    alt: "Monterey",
  },
  {
    src: "https://cdn.filestackcontent.com/zrxAgqGQBuAx0lmT1A41",
    alt: "Mountain View",
  },
  {
    src: "https://cdn.filestackcontent.com/VNYTOdLTSAaSFGertOeU",
    alt: "San Mateo County",
  },
  {
    src: "https://cdn.filestackcontent.com/PNmpz3iYTim5Rupi41zK",
    alt: "Commerce City",
  },
  {
    src: "https://cdn.filestackcontent.com/ignACIYT6mXclYkKYAjs",
    alt: "Lone Tree",
  },
  {
    src: "https://cdn.filestackcontent.com/MPpVURSRaqO2bqMTRxX5",
    alt: "Loveland",
  },
  {
    src: "https://cdn.filestackcontent.com/QvnQDCeTAi22MvwkibbR",
    alt: "Westminster",
  },
  {
    src: "https://cdn.filestackcontent.com/YkwrCzvYTIa0Je8XlfMR",
    alt: "Gulf County",
  },
  {
    src: "https://cdn.filestackcontent.com/z42fnDxnSV6EmsnQHR2u",
    alt: "Bowling Green",
  },
  {
    src: "https://cdn.filestackcontent.com/wpD9950zT9CC2oLZvDil",
    alt: "Citrus County",
  },
  {
    src: "https://cdn.filestackcontent.com/xXlf3KqQ2OUXddYs0ts9",
    alt: "Hallandale Beach",
  },
  {
    src: "https://cdn.filestackcontent.com/W5U4l0z7Rn6cZdh5xh2J",
    alt: "Leon County",
  },
  {
    src: "https://cdn.filestackcontent.com/DRpYcLsFRIJPp5yCI8JQ",
    alt: "Miami Lakes",
  },
  {
    src: "https://cdn.filestackcontent.com/lsBNvs8TRir2TQWG8XGA",
    alt: "Seminole County",
  },
  {
    src: "https://cdn.filestackcontent.com/kvDOQWvESsmkzNr5uiCE",
    alt: "Algonquin",
  },
  {
    src: "https://cdn.filestackcontent.com/UaWa0590QquynL6o06AF",
    alt: "Kendall County",
  },
  {
    src: "https://cdn.filestackcontent.com/ORGw7TdvTlqi3kzG43SB",
    alt: "Roselle",
  },
  {
    src: "https://cdn.filestackcontent.com/jDYWcymRTGny7sxuQmai",
    alt: "Bartlett",
  },
  {
    src: "https://cdn.filestackcontent.com/udBs4Yo0S5SjhJtA5DK1",
    alt: "Will County",
  },
  {
    src: "https://cdn.filestackcontent.com/kspdklRaSsC4xn0b71JL",
    alt: "Lancaster",
  },
  {
    src: "https://cdn.filestackcontent.com/9VibV8RR4JCA57tgamkg",
    alt: "Reading",
  },
  {
    src: "https://cdn.filestackcontent.com/3ZobEnMRIiPbmQYpUARQ",
    alt: "Belmont",
  },
  {
    src: "https://cdn.filestackcontent.com/JuhUeijsT42qEDCd7TB2",
    alt: "Sanger",
  },
  {
    src: "https://cdn.filestackcontent.com/NZ4vMUisRiSeUjGadiHx",
    alt: "Fort Madison",
  },
  {
    src: "https://cdn.filestackcontent.com/zOQhHIcWTrEzYrkTnbR8",
    alt: "Emporia",
  },
  {
    src: "https://cdn.filestackcontent.com/rLzY9rKR2yO45niL7kLg",
    alt: "Havre De Grace",
  },
  {
    src: "https://cdn.filestackcontent.com/cCMRS8BKRneNOUkDLK9T",
    alt: "Caguas",
  },
  {
    src: "https://cdn.filestackcontent.com/rUdsV5r4TOV78bMNvi9I",
    alt: "Farmington",
  },
  {
    src: "https://cdn.filestackcontent.com/gl7eKa20RdCUJuhM6P3K",
    alt: "Delaware",
  },
  {
    src: "https://cdn.filestackcontent.com/q0hRhGphTvCUVqsHQ0xY",
    alt: "Dallas",
  },
  {
    src: "https://cdn.filestackcontent.com/eJDGqLvhTj6LrYMniPMV",
    alt: "Harrisburg",
  },
  {
    src: "https://cdn.filestackcontent.com/Hl1yAgJvRZqYjVCuhl07",
    alt: "Elkhorn",
  },
  {
    src: "https://cdn.filestackcontent.com/CikktjjnQOScEBX8PrCH",
    alt: "Tempe",
  },
  {
    src: "https://cdn.filestackcontent.com/w7gQydH5RjCxrZSlRuLl",
    alt: "Sedona",
  },
  {
    src: "https://cdn.filestackcontent.com/fDLlxIe9RKWLDhx45I4Q",
    alt: "Roswell",
  },
  {
    src: "https://cdn.filestackcontent.com/zdGCC0jaTUiPBeIpwzrc",
    alt: "Casa Grande",
  },
  {
    src: "https://cdn.filestackcontent.com/W9OdKRMkR2atF10CyFjM",
    alt: "Carmel",
  },
  {
    src: "https://cdn.filestackcontent.com/7Yv1xLfySOW7utviTUo2",
    alt: "Cleveland Heights",
  },
  {
    src: "https://cdn.filestackcontent.com/mKqw7EeTSr2azeuug40Q",
    alt: "Bend",
  },
  {
    src: "https://cdn.filestackcontent.com/he4ZukeVSCWDvcrLwc5i",
    alt: "Alpharetta",
  },
  {
    src: "https://cdn.filestackcontent.com/DDVeSn6uToGgaq7bFU4X",
    alt: "Airway Heights",
  },
  {
    src: "https://cdn.filestackcontent.com/ShdwWLA6SoKxXX36KxOw",
    alt: "Westwood",
  },
  {
    src: "https://cdn.filestackcontent.com/Hja5YJnoQwC8yZ2xaHLp",
    alt: "Metuchen",
  },
  {
    src: "https://cdn.filestackcontent.com/hBpsjlp6QSakzS6hZNvd",
    alt: "Wharton",
  },
  {
    src: "https://cdn.filestackcontent.com/i0KGG1QCGelCgd86c8AA",
    alt: "Olathe",
  },
  {
    src: "https://cdn.filestackcontent.com/RzK6JJPTd2flppyWQznx",
    alt: "Manhattan",
  },
  {
    src: "https://cdn.filestackcontent.com/KZuHTZVkTVmulPX70FHc",
    alt: "Topeka",
  },
  {
    src: "https://cdn.filestackcontent.com/lTlyCrCRqytopnp6380A",
    alt: "Salisbury",
  },
  {
    src: "https://cdn.filestackcontent.com/jhOf12zlTqalFPs6xdCR",
    alt: "Shreveport",
  },
  {
    src: "https://cdn.filestackcontent.com/Zb9CnLQQOacE1RpPFee7",
    alt: "Rockville",
  },
  {
    src: "https://cdn.filestackcontent.com/c0WCanMCTDGOPGD4OL2Y",
    alt: "Lake Saint Louis",
  },
  {
    src: "https://cdn.filestackcontent.com/OO4HmvrgQLCjrNG8GCLQ",
    alt: "New Ulm",
  },
  {
    src: "https://cdn.filestackcontent.com/QCkq3alIRF6BKTUuFp6c",
    alt: "Rochester",
  },
  {
    src: "https://cdn.filestackcontent.com/4LxeRihMTw6bx4drjjdl",
    alt: "Southaven",
  },
  {
    src: "https://cdn.filestackcontent.com/Ew27xNKeTE6doATiqi2r",
    alt: "Orem",
  },
  {
    src: "https://cdn.filestackcontent.com/8kjoorYQQ60lB9z4SpIg",
    alt: "St Charles",
  },
  {
    src: "https://cdn.filestackcontent.com/U2yhEJwMRxaD5C3FbKvs",
    alt: "King City",
  },
  {
    src: "https://cdn.filestackcontent.com/OwtHVpOQC693Vfxp4QNQ",
    alt: "Lynchburg",
  },
  {
    src: "https://cdn.filestackcontent.com/J0gMkiPPRNaLDhUrymJE",
    alt: "Reno",
  },
  {
    src: "https://cdn.filestackcontent.com/IEMsm0Qe72AVsxeGMCAP",
    alt: "Oconomowoc",
  },
  {
    src: "https://cdn.filestackcontent.com/Cl8cDSIRMqJc9mDjJfm6",
    alt: "High Point",
  },
  {
    src: "https://cdn.filestackcontent.com/zjMBRHUwTNOYfk6VoSXJ",
    alt: "Pima County",
  },
  {
    src: "https://cdn.filestackcontent.com/agnFJ0mQuWAVWljXrvvw",
    alt: "Forsyth County",
  },
  {
    src: "https://cdn.filestackcontent.com/W7PH8GuATL2IKKfjvE7E",
    alt: "Los Alamos County",
  },
  {
    src: "https://cdn.filestackcontent.com/QEMUhUkeTh6fTcjMaPid",
    alt: "Hoke County",
  },
  {
    src: "https://cdn.filestackcontent.com/PmiJN0ckSZeevITAiA71",
    alt: "Mecklenburg County",
  },
  {
    src: "https://cdn.filestackcontent.com/X8VDNj8oR7tjKT8WDpE6",
    alt: "Union County",
  },
  {
    src: "https://cdn.filestackcontent.com/YQHPzK6TmalPD4n6zOwX",
    alt: "Wake County",
  },
  {
    src: "https://cdn.filestackcontent.com/OybhKluBRuykstVhWRru",
    alt: "Cuyahoga County",
  },
  {
    src: "https://cdn.filestackcontent.com/fzTDhcZ7QSqdCPHyo6Du",
    alt: "Defiance County",
  },
  {
    src: "https://cdn.filestackcontent.com/L4BAOfkSTwSJDD6NsgXo",
    alt: "Fairfield County",
  },
  {
    src: "https://cdn.filestackcontent.com/FXq3Me1JQa2xD7Q18xJs",
    alt: "Oklahoma County",
  },
  {
    src: "https://cdn.filestackcontent.com/SfJ9QrJTFKXs2ecwYDbw",
    alt: "Klamath County",
  },
  {
    src: "https://cdn.filestackcontent.com/rD95ppQvSM6cOgekN24Q",
    alt: "Multnomah County",
  },
  {
    src: "https://cdn.filestackcontent.com/O0tYgvTdGGo2mtLsk9RA",
    alt: "Chester County",
  },
  {
    src: "https://cdn.filestackcontent.com/rR2pCrSvTbCqnwOxGYQU",
    alt: "Jefferson County",
  },
  {
    src: "https://cdn.filestackcontent.com/vZvgc4paR6Ghhzr26JUI",
    alt: "Davis County",
  },
  {
    src: "https://cdn.filestackcontent.com/6rvXMiW9SNG6eg3Othzs",
    alt: "Duchesne County",
  },
  {
    src: "https://cdn.filestackcontent.com/RRj18iRWSfmZNvtuICzs",
    alt: "Salt Lake County",
  },
  {
    src: "https://cdn.filestackcontent.com/xlYG9cABSam7HemyuouJ",
    alt: "Arlington County",
  },
  {
    src: "https://cdn.filestackcontent.com/oVINbVutQu6CGGrTZiCd",
    alt: "Fairfax County",
  },
  {
    src: "https://cdn.filestackcontent.com/3CFRTzTRTliLsSWAok0I",
    alt: "King County",
  },
  {
    src: "https://cdn.filestackcontent.com/MIiMYPTqQoMm87GTEbHC",
    alt: "San Juan County",
  },
  {
    src: "https://cdn.filestackcontent.com/6JD5AJm9TL6NurjXOPty",
    alt: "Dunn County",
  },
  {
    src: "https://cdn.filestackcontent.com/KQQIbdITLuBuGo83vU6i",
    alt: "Hamilton County",
  },
  {
    src: "https://cdn.filestackcontent.com/ePe4zy3UTJaK0ohDWWLA",
    alt: "Wyoming",
  },
  {
    src: "https://cdn.filestackcontent.com/KR60IQTUTEediD6AzCmA",
    alt: "West Burlington",
  },
  {
    src: "https://cdn.filestackcontent.com/fSqpi5NTHu7NJMqMUD1Q",
    alt: "Prince Georges County",
  },
  {
    src: "https://cdn.filestackcontent.com/fbYLYP5wSQqhv4rVVV7u",
    alt: "Hennepin County",
  },
  {
    src: "https://cdn.filestackcontent.com/6yCBAuugTpezwLpoMxDB",
    alt: "Ramsey County",
  },
  {
    src: "https://cdn.filestackcontent.com/s7op38u6S4WJ5k59Fn1Y",
    alt: "St Louis County",
  },
  {
    src: "https://cdn.filestackcontent.com/5EGdNHObSLGvRAbmO0SA",
    alt: "Clark County",
  },
  {
    src: "https://cdn.filestackcontent.com/QWFSTaOdTDWfLszwvJkO",
    alt: "Nye County",
  },
  {
    src: "https://cdn.filestackcontent.com/Kx8r1aRpGGitSKf8tWCA",
    alt: "Princeton",
  },
  {
    src: "https://cdn.filestackcontent.com/81mwZuPTTPCFcflA8Thu",
    alt: "Tyrone",
  },
  {
    src: "https://cdn.filestackcontent.com/Ubumvj6jTdKS18JNLYD3",
    alt: "Calcasieu County",
  },
  {
    src: "https://cdn.filestackcontent.com/fXL6Vy07QSDQhffg2R3i",
    alt: "Ashland",
  },
  {
    src: "https://cdn.filestackcontent.com/Es0TrdjTRGBR8JVyCeGG",
    alt: "Horsham",
  },
  {
    src: "https://cdn.filestackcontent.com/ZFQggr0QDePLBUARCJ89",
    alt: "Lincoln",
  },
  {
    src: "https://cdn.filestackcontent.com/eCJPM2cKQUaBc5JeTcta",
    alt: "Nutley",
  },
  {
    src: "https://cdn.filestackcontent.com/czZLHWl7R4qZTKUjRKE7",
    alt: "West Donegal",
  },
  {
    src: "https://cdn.filestackcontent.com/UoA9j6ilTOmYI926OXRA",
    alt: "Verona",
  },
  {
    src: "https://cdn.filestackcontent.com/gkduvvkQgKwBqYg47sA4",
    alt: "Cranberry",
  },
  {
    src: "https://cdn.filestackcontent.com/jZou4GMLQLuhCCSetW2w",
    alt: "Horry County",
  },
  {
    src: "https://cdn.filestackcontent.com/8t2D3VSRxStTiE0MgGAg",
    alt: "Kershaw County",
  },
  {
    src: "https://cdn.filestackcontent.com/3776TBpURywluQvnXA85",
    alt: "Rock Springs",
  },
  {
    src: "https://cdn.filestackcontent.com/JSwJvt22R4eoywPsPUNM",
    alt: "Grand Forks",
  },
  {
    src: "https://cdn.filestackcontent.com/NE1Z9fptSBm4JAUwJjGT",
    alt: "Macomb County",
  },
  {
    src: "https://cdn.filestackcontent.com/POhOZooTzeibDgXKEdPg",
    alt: "Charleston",
  },
  {
    src: "https://cdn.filestackcontent.com/O9RDOhfEQt2jOFLeqyj5",
    alt: "Myrtle Beach",
  },
  {
    src: "https://cdn.filestackcontent.com/ljEhfPiQpmpMmugFZAeA",
    alt: "Gulf Shores",
  },
  {
    src: "https://cdn.filestackcontent.com/hExBCr90RMuNHRX699Rt",
    alt: "Montgomery",
  },
  {
    src: "https://cdn.filestackcontent.com/DMOPO1N1TciuEgFcWRbg",
    alt: "Tiverton",
  },
  {
    src: "https://cdn.filestackcontent.com/oCMge7wkSvmuHdxc0BR8",
    alt: "South Kingstown",
  },
  {
    src: "https://cdn.filestackcontent.com/PRAxtrxHRemCTs0pDMCO",
    alt: "Portland",
  },
  {
    src: "https://cdn.filestackcontent.com/irekOAsXQYGE2TabEBN5",
    alt: "Sioux Falls",
  },
  {
    src: "https://cdn.filestackcontent.com/aeRwEo3RRWAmnXshLV7w",
    alt: "Rochester",
  },
  {
    src: "https://cdn.filestackcontent.com/q2yHyik9TIqwAlAhJUb1",
    alt: "Providence",
  },
  {
    src: "https://cdn.filestackcontent.com/mMFM9xnZRmaXfV9H84ZR",
    alt: "Los Angeles",
  },
  {
    src: "https://cdn.filestackcontent.com/blSXjBPERv6Y3BXNvLGN",
    alt: "Asheville",
  },
  {
    src: "https://cdn.filestackcontent.com/9HR57JfTTOcB5T6nXLyl",
    alt: "San Diego",
  },
  {
    src: "https://cdn.filestackcontent.com/FiHBU08FQb2dhnbwnRFa",
    alt: "Arlington",
  },
  {
    src: "https://cdn.filestackcontent.com/NaIZnBvVRQIOGiGQyu6m",
    alt: "Boston",
  },
  {
    src: "https://cdn.filestackcontent.com/AlhC1u6S4K0rnaekYvxA",
    alt: "Chicago",
  },
  {
    src: "https://cdn.filestackcontent.com/E6qYcw2SQemxgjWZS4Hr",
    alt: "Cincinnati",
  },
  {
    src: "https://cdn.filestackcontent.com/itZI54nvSW2XzSoZ3dZs",
    alt: "Dallas",
  },
  {
    src: "https://cdn.filestackcontent.com/Ts6BD05UTCy38HIZNFqy",
    alt: "Denver",
  },
  {
    src: "https://cdn.filestackcontent.com/S1fiEqGdSiO1VzjvITCk",
    alt: "Houston",
  },
  {
    src: "https://cdn.filestackcontent.com/kWL2SlqsSJayWG0QlMeY",
    alt: "Jacksonville",
  },
  {
    src: "https://cdn.filestackcontent.com/jB8juUYsTImEPGdAkPq9",
    alt: "Jersey City",
  },
  {
    src: "https://cdn.filestackcontent.com/RxGACLSVdXBoH2gkQawI",
    alt: "Long Beach",
  },
  {
    src: "https://cdn.filestackcontent.com/COwoYkoETVSR3aC4BEvy",
    alt: "Miami",
  },
  {
    src: "https://cdn.filestackcontent.com/w4hZHwT6TGaP2N02CKhi",
    alt: "New York",
  },
  {
    src: "https://cdn.filestackcontent.com/KBtddBhtQrKASWt9nbP7",
    alt: "Orlando",
  },
  {
    src: "https://cdn.filestackcontent.com/NJLS55QmQSiNg17EkXwy",
    alt: "Riverside",
  },
  {
    src: "https://cdn.filestackcontent.com/Yd5DLKzTsSHS84R12t3t",
    alt: "San Francisco",
  },
  {
    src: "https://cdn.filestackcontent.com/pBkfWdFRJiFFSd7QbxFT",
    alt: "Santa Monica",
  },
  {
    src: "https://cdn.filestackcontent.com/46XIlz0SDmSyPCCz17yl",
    alt: "South Bend",
  },
  {
    src: "https://cdn.filestackcontent.com/1j1xTIayROieetJzYsaM",
    alt: "Tulsa",
  },
  {
    src: "https://cdn.filestackcontent.com/aXVtdsOUTT6X0jBE7G3J",
    alt: "Govtopia",
  },
  {
    src: "https://cdn.filestackcontent.com/57pUA6BgQvCls1UtS8O0",
    alt: "Philadelphia",
  },
  {
    src: "https://cdn.filestackcontent.com/hEiENFgwRN2EGYUXf4NX",
    alt: "Cary",
  },
  {
    src: "https://cdn.filestackcontent.com/DqQ3CepjSX6KQYJZFMhO",
    alt: "Greensboro",
  },
  {
    src: "https://cdn.filestackcontent.com/oH30VJ3QDeRS5DBuk4IA",
    alt: "Columbus",
  },
  {
    src: "https://cdn.filestackcontent.com/jatoaSaStCMoGBEdPfeQ",
    alt: "Scottsdale",
  },
  {
    src: "https://cdn.filestackcontent.com/B5fyIsGgTd6ipdp2kTpM",
    alt: "Savannah",
  },
  {
    src: "https://cdn.filestackcontent.com/uKImbc5jTRud7TAjvCXw",
    alt: "South Fulton",
  },
  {
    src: "https://cdn.filestackcontent.com/mQ9IzSCsSXq0scuFoAHY",
    alt: "Clarksville",
  },
  {
    src: "https://cdn.filestackcontent.com/tot2LMsRRmfhLKKWDNQe",
    alt: "Durham",
  },
  {
    src: "https://cdn.filestackcontent.com/8UM3kzh6SgeRVzQJLvNV",
    alt: "Mansfield",
  },
  {
    src: "https://cdn.filestackcontent.com/GGkccHgRSRGPLbQ2vdQo",
    alt: "Sacramento",
  },
  {
    src: "https://cdn.filestackcontent.com/dZRMx6URwWIjACRjny8l",
    alt: "Baltimore",
  },
  {
    src: "https://cdn.filestackcontent.com/Gx02klu2RUqZte1V1CaV",
    alt: "Albuquerque",
  },
  {
    src: "https://cdn.filestackcontent.com/myBNhgTTS2Q0ZjTD5nIA",
    alt: "Raleigh",
  },
  {
    src: "https://cdn.filestackcontent.com/2dcVUr9RhCeZKDzMKIYC",
    alt: "Portland",
  },
  {
    src: "https://cdn.filestackcontent.com/h91W0rFlTmqHZFAEsEj4",
    alt: "Seattle",
  },
  {
    src: "https://cdn.filestackcontent.com/95QSnswPR4uy53XMTtXn",
    alt: "Honolulu",
  },
  {
    src: "https://cdn.filestackcontent.com/YdHEE4nSTna9ObmZws9R",
    alt: "Gilbert",
  },
  {
    src: "https://cdn.filestackcontent.com/K6TPwhmQriyjakFmp0HW",
    alt: "Sullivan",
  },
  {
    src: "https://cdn.filestackcontent.com/yhkZsCTTQE6xU4eF5iBS",
    alt: "Cabarrus County",
  },
  {
    src: "https://cdn.filestackcontent.com/wpPXiegiQaKD0ITl5IFG",
    alt: "Wichita",
  },
  {
    src: "https://cdn.filestackcontent.com/9pWb7GxaTdCva8YPhTkk",
    alt: "Charlotte",
  },
  {
    src: "https://cdn.filestackcontent.com/h2zTqTXcSFW2krcrwvxI",
    alt: "Oakland",
  },
  {
    src: "https://cdn.filestackcontent.com/SsIaB5iR4WdZ4fECvwqA",
    alt: "Pittsburgh",
  },
  {
    src: "https://cdn.filestackcontent.com/IrYtruUQyyuiyEztt6Gg",
    alt: "Detroit",
  },
  {
    src: "https://cdn.filestackcontent.com/Qg75gkHKQL6ikDG8FvVT",
    alt: "Mount Vernon",
  },
  {
    src: "https://cdn.filestackcontent.com/M6g38MaTRr6OQgQmQqZK",
    alt: "Champaign",
  },
  {
    src: "https://cdn.filestackcontent.com/nEYYthcTcCe8p41HqzcC",
    alt: "Webster County",
  },
  {
    src: "https://cdn.filestackcontent.com/gNh7QGQOR8OKI6DmnI5M",
    alt: "Lexington",
  },
  {
    src: "https://cdn.filestackcontent.com/o68XxNdSQIO07lUFhag0",
    alt: "Gibsonville",
  },
  {
    src: "https://cdn.filestackcontent.com/SZVZw1pBS5iLleysiLsq",
    alt: "Culver City",
  },
  {
    src: "https://cdn.filestackcontent.com/OInCHxYS4y3oihCG8j7C",
    alt: "Boulder County",
  },
  {
    src: "https://cdn.filestackcontent.com/YAjkkYFMS06aKfdYezFz",
    alt: "Indianapolis",
  },
  {
    src: "https://cdn.filestackcontent.com/hPrvlgtESQS21Qjr4H39",
    alt: "Norfolk",
  },
  {
    src: "https://cdn.filestackcontent.com/rPtk1cPLTtyN4O1HQ5xr",
    alt: "Rutherford County",
  },
  {
    src: "https://cdn.filestackcontent.com/GXE0DZhkS1CHjiQgpl55",
    alt: "Berkley",
  },
  {
    src: "https://cdn.filestackcontent.com/bwjtOcxNRya0X6NFkGnA",
    alt: "West Chester",
  },
  {
    src: "https://cdn.filestackcontent.com/jkNFX7vQuahunO4lEMcT",
    alt: "Barnstable County",
  },
  {
    src: "https://cdn.filestackcontent.com/CtjPqjCSk2X38e1GCFEQ",
    alt: "Mesa",
  },
];
